import { render, staticRenderFns } from "./OrderTotals.vue?vue&type=template&id=29455d75&"
import script from "./OrderTotals.vue?vue&type=script&lang=js&"
export * from "./OrderTotals.vue?vue&type=script&lang=js&"
import style0 from "./OrderTotals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports